import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { coreActions } from '@sonar-software/sonar-core';
import React from 'react';
import { StakeholderSelector } from '@ui/StakeholderSelector';
import { useAction, useOnMount, useSonarObjectReference } from '@hooks';

export interface SonarObjectStakeholdersProps {
	getPopupContainer?: (trigger: HTMLElement) => HTMLElement;
	isSpreadsheet?: boolean;
	sonarObjectId: number;
	withLatest?: boolean;
	direction?: 'horizontal' | 'vertical';
}

export const SonarObjectStakeholders: React.FC<SonarObjectStakeholdersProps> = ({
	getPopupContainer,
	isSpreadsheet,
	sonarObjectId,
	withLatest,
	direction
}) => {
	const stakeholders = useSonarObjectReference(sonarObjectId)?.stakeholders ?? [];

	const getBusinessContextStakeholders = useAction(coreActions.requestGetCoreSonarObjectsStakeholders);
	const updateBusinessContextStakeholders = useAction(coreActions.requestPutCoreSonarObjectsStakeholders);

	useOnMount(() => {
		if (withLatest) {
			getBusinessContextStakeholders({ sonarObjectId });
		}
	});

	const handleChange = (stakeholderIds: number[]) => {
		updateBusinessContextStakeholders({
			sonarObjectId,
			stakeholderIds
		});
	};

	return (
		<StakeholderSelector
			avatar
			direction={ direction }
			getPopupContainer={ getPopupContainer }
			isSpreadsheet={ isSpreadsheet }
			mode='multiple'
			onChange={ handleChange }
			placeholder={ COPY_SPECIFIC.ADD_STAKEHOLDERS }
			value={ stakeholders } />
	);
};
